export default {
  dark (state, getters, rootState, rootGetters) {
    return rootGetters['L/dark']
  },
  isDevelopment (state) {
    return process.env.NODE_ENV !== 'production'
  },
}
